"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
var SvgPaymentSkeletonMobile = function SvgPaymentSkeletonMobile(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 367 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h367v256H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 8h351v116H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 19.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 27h252.5M18 42h333M18 58h333M18 74h333M18 90h333M18 106h204",
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M8 132h351v116H8z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 143.5,
    width: 15,
    height: 15,
    rx: 7.5,
    stroke: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38 151h252.5M18 166h333M18 182h333M18 198h333M18 214h333M18 230h204",
    stroke: "#E6E6E6"
  }));
};
var Memo = /*#__PURE__*/(0, _react.memo)(SvgPaymentSkeletonMobile);
var _default = exports["default"] = Memo;